import { useEffect, useState } from 'react';
import { api, downloadFile } from '../api';

const BASE = '/api';

function downloadReport(url) {
  downloadFile(url).catch(e => alert(e.message));
}

function buildUrl(path, params) {
  const q = Object.entries(params).filter(([, v]) => v).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&');
  return `${BASE}/reports${path}${q ? '?' + q : ''}`;
}

export default function Reports() {
  const [devices, setDevices] = useState([]);
  const [ticketFilters, setTicketFilters] = useState({ status: '', from: '', to: '' });
  const [revenueFilters, setRevenueFilters] = useState({ status: '', from: '', to: '' });
  const [deviceId, setDeviceId] = useState('');

  useEffect(() => {
    fetch(`${BASE}/reports/devices-list`).then(r => r.json()).then(setDevices).catch(() => {});
  }, []);

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">REPORTS <span>_</span></h1>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 16 }}>

        {/* Tickets Report */}
        <div className="card">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
            <div style={{ fontSize: 24 }}>🎫</div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>Tickets Report</div>
              <div className="text-dim text-xs">All repair tickets with device info</div>
            </div>
          </div>
          <div className="field">
            <label>Status</label>
            <select className="select" value={ticketFilters.status} onChange={e => setTicketFilters(f => ({ ...f, status: e.target.value }))}>
              <option value="">All Statuses</option>
              <option value="received">Received</option>
              <option value="in_repair">In Repair</option>
              <option value="done">Done</option>
              <option value="delivered">Delivered</option>
            </select>
          </div>
          <div className="grid-2">
            <div className="field">
              <label>From</label>
              <input type="date" className="input" value={ticketFilters.from} onChange={e => setTicketFilters(f => ({ ...f, from: e.target.value }))} />
            </div>
            <div className="field">
              <label>To</label>
              <input type="date" className="input" value={ticketFilters.to} onChange={e => setTicketFilters(f => ({ ...f, to: e.target.value }))} />
            </div>
          </div>
          <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}
            onClick={() => downloadReport(buildUrl('/tickets', ticketFilters))}>
            ⬇ Download Excel
          </button>
        </div>

        {/* Revenue Report */}
        <div className="card">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
            <div style={{ fontSize: 24 }}>🧾</div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>Revenue Report</div>
              <div className="text-dim text-xs">Invoices with amounts and payment status</div>
            </div>
          </div>
          <div className="field">
            <label>Status</label>
            <select className="select" value={revenueFilters.status} onChange={e => setRevenueFilters(f => ({ ...f, status: e.target.value }))}>
              <option value="">All Statuses</option>
              <option value="issued">Issued</option>
              <option value="sent">Sent</option>
              <option value="paid">Paid</option>
            </select>
          </div>
          <div className="grid-2">
            <div className="field">
              <label>From</label>
              <input type="date" className="input" value={revenueFilters.from} onChange={e => setRevenueFilters(f => ({ ...f, from: e.target.value }))} />
            </div>
            <div className="field">
              <label>To</label>
              <input type="date" className="input" value={revenueFilters.to} onChange={e => setRevenueFilters(f => ({ ...f, to: e.target.value }))} />
            </div>
          </div>
          <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}
            onClick={() => downloadReport(buildUrl('/revenue', revenueFilters))}>
            ⬇ Download Excel
          </button>
        </div>

        {/* Parts & Warranty Report */}
        <div className="card">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
            <div style={{ fontSize: 24 }}>🔩</div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>Parts & Warranty Report</div>
              <div className="text-dim text-xs">All parts with warranty status and faulty flags</div>
            </div>
          </div>
          <p className="text-sm text-muted" style={{ marginBottom: 16 }}>
            Exports all parts across all tickets — highlights faulty parts and warranty expiry dates.
          </p>
          <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 'auto' }}
            onClick={() => downloadReport(buildUrl('/parts', {}))}>
            ⬇ Download Excel
          </button>
        </div>

        {/* Device History Report */}
        <div className="card">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
            <div style={{ fontSize: 24 }}>🔧</div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>Device History Report</div>
              <div className="text-dim text-xs">Full repair history for a single device</div>
            </div>
          </div>
          <div className="field">
            <label>Select Device</label>
            <select className="select" value={deviceId} onChange={e => setDeviceId(e.target.value)}>
              <option value="">— Choose a device —</option>
              {devices.map(d => (
                <option key={d.id} value={d.id}>
                  {d.name} — {d.serial}{d.alias ? ` (${d.alias})` : ''}
                </option>
              ))}
            </select>
          </div>
          <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}
            disabled={!deviceId}
            onClick={() => downloadReport(`${BASE}/reports/device/${deviceId}`)}>
            ⬇ Download Excel
          </button>
        </div>

      </div>
    </div>
  );
}
